import { h } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';

import { withHomeEntBehavior } from 'components/editor/movies/homeEnt/homeEnt';
import UniversalWatchPageEditor from 'components/editor/movies/watch/watchUniversal';
import SelectableSection from 'components/editor/selectableSection';

import s from 'components/editor/movies/homeEnt/homeEntUniversal.sss';

export default class UniversalHomeEntEditor extends withHomeEntBehavior(UniversalWatchPageEditor) {
	s = s; // Styling will only be assigned in the final implementation (i.e. homeEntUniversal.js)

	renderMainHeader() {
		const parentStyle = {};
		const customBackground = this.getData().header?.bg;
		if (customBackground) {
			parentStyle.backgroundImage = `url("${customBackground}")`;
		}

		const data = this.getData();
		const filters = data?.filters;
		const hasMultipleSections = Object.keys(data?.sections || {}).length > 1;

		return (
			<SelectableSection class={joinClasses(this.s.mainHeader, customBackground && this.s.customBackground)} section="/pages/homeEnt/header" {...this.props} style={parentStyle}>
				<div class={this.s.modes}>
					{hasMultipleSections && <div class={this.s.mode}>All</div>}
					{sortObjectByOrder(data.sections, (section, key) => (
						<SelectableSection class={this.s.mode} section={`/pages/homeEnt/filters/${key}`} {...this.props} key={key}>
							{filters?.[key]?.title || section.title}
						</SelectableSection>
					))}
				</div>
			</SelectableSection>
		);
	}
}